<template>
  <v-card height="100%">
    <v-card-item>
      <v-card-title>
        <sf-heading>{{ $t('common.comment') }}</sf-heading>
      </v-card-title>
    </v-card-item>
    <v-card-text>
      <sf-debounced-textarea
        ref="comment-input"
        v-model="model"
        :placeholder="$t('common.commentPlaceholder')"
        auto-grow
        density="compact"
        hide-details="auto"
        :readonly="!editable"
        variant="underlined"
        color="primary"
        rows="1"
        autocomplete="off"
        :maxlength="maxLength"
        :rules="rules"
        :hint="model && model.length >= maxLength ? $t('maxLength', [maxLength]) : ''"
        persistent-hint
        @debounce="onDebounce"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import SfDebouncedTextarea from '@/components/input/SfDebouncedTextarea.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import { PropType } from 'vue'

const props = defineProps({
  editable: {
    type: Boolean,
    default: true
  },
  maxLength: {
    type: Number,
    required: true
  },
  rules: {
    type: Array as PropType<((value: string) => boolean | string)[]>,
    default: () => []
  }
})
const emit = defineEmits(['debounce'])
const model = defineModel<string | null>()

const onDebounce = (value: string) => {
  if (props.editable) {
    emit('debounce', value)
  }
}
</script>
